import { History } from 'history'
import { applyMiddleware, createStore, Middleware } from 'redux'
import reduxFreeze from 'redux-freeze'
import { createLogger } from 'redux-logger'
import createSagaMiddleware from 'redux-saga'

import rootReducer from './rootReducer'
import rootSaga from './rootSaga'

interface IModule extends NodeModule {
  hot: {
    accept: (reducer: string, fn: () => void) => void
  }
}

declare const module: IModule

// todo: disable logging on production
const logger = createLogger({
  collapsed: true,
  colors: {
    title: (action) => {
      if (action.type.match(/_REQUEST/g)) {
        return 'black'
      } else if (action.type.match(/_ERROR$/g)) {
        return 'red'
      } else if (action.type.match(/_SUCCESS/g)) {
        return 'green'
      } else {
        return 'gray'
      }
    },
  },
  duration: true,
})

const errorMiddleware = () => (next: any) => (action: any) => {
  try {
    return next(action)
  } catch (error) {
    // Log error here
  }
}

const sagaMiddleware = createSagaMiddleware()

export default function configureStore(initialState = {}, history: History) {
  // Compose final middleware and use devtools in debug environment

  const allowDebug = process.env.NODE_ENV !== 'production'

  const middlewares: Middleware[] = [errorMiddleware, sagaMiddleware]

  if (allowDebug) {
    middlewares.push(logger, reduxFreeze)
  }

  const middleware = applyMiddleware(...middlewares)

  // Create final store and subscribe router in debug env ie. for devtools
  const store = middleware(createStore)(rootReducer, initialState)
  let sagaTask = sagaMiddleware.run(rootSaga)

  if (module.hot) {
    module.hot.accept('redux/rootReducer', () => {
      const nextRootReducer = require('redux/rootReducer').default
      store.replaceReducer(nextRootReducer)
    })

    module.hot.accept('redux/rootSaga', () => {
      const newSagas = require('redux/rootSaga').default
      sagaTask.cancel()
      sagaTask.toPromise().then(() => {
        sagaTask = sagaMiddleware.run(newSagas)
      })
    })
  }
  return store
}
